<template>
  <div
    class="tab-no-data"
    data-qa="tab-no-data">
    <div class="tab-no-data-label">
      {{ text || $t('Common.NoData') }}
    </div>
    <div
      class="tab-no-data-img">
      <sIcon
        color="#ced8d7"
        size="75"
        type="comment"/>
      <sIcon
        color="#ced8d7"
        flip="horizontal"
        line-height="155px"
        size="43"
        style="margin-left: 16px;"
        type="comment"/>
    </div>
  </div>
</template>
<script>
/**
 * Блок для табов с пустой информацией "Вопросы", "История" и т.п.
 */
export default {
  name: 'emptyTab',
  props: {
    /**
     * Текст в блоке
     */
    text: {
      type: String,
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-no-data {
  max-width: 300px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
}
.tab-no-data-img {
  display: flex;
  padding-top: 10px;
  padding-right: 95px;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
}
.tab-no-data-label {
  font-size: 14px;
  text-align: left;
  width: 100%;
  text-align: center;
}
</style>
